import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 支払い方法
 */
export class SctActHowToPay extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): SctActHowToPay {
    return new SctActHowToPay(value);
  }
}
